import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "11px",
	height: "9px",
	viewBox: "0 0 11 9",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Icon" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Done-Notification-",
				transform: "translate(-5.000000, -6.000000)",
				fill: "#3ed13b",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9.0445875,11.882736 L14.4207058,6.25376766 C14.7438639,5.91541078 15.2678067,5.91541078 15.5909648,6.25376766 C15.9141229,6.59212455 15.9141229,7.14070945 15.5909648,7.47906634 L9.0445875,14.3333333 L5.24236857,10.3522881 C4.91921048,10.0139313 4.91921048,9.46534636 5.24236857,9.12698947 C5.56552666,8.78863259 6.08946944,8.78863259 6.41262753,9.12698947 L9.0445875,11.882736 Z",
					id: "Icon"
				})
			})
		})
	]
});
export default SvgCheckGreen;
